import { Fragment } from "react";

export default function DevotionReferences({ devotion, className }) {
  const references = devotion.references || (devotion.reference || "")
    .split(";").map(reference => ({ reference: reference.trim() })).filter(p => p.reference);
  return references.map((passage, index) => (
    <Fragment key={`${index}-${passage.reference}`}>
      {index > 0 && "; "}
      <a href={`https://www.biblegateway.com/passage/?search=${encodeURIComponent(passage.reference)}&version=KJV`}
        target="_blank" rel="noreferrer" className={className}>
        {passage.reference} (KJV) ↗
      </a>
    </Fragment>
  ));
}
